import React, { useContext, useEffect, useState } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import PropTypes from 'prop-types';
import { ACADEMY_LIST_ITEM_TYPE } from '../../../services/utilityFunctions';
import translate from '../../../commonComponents/translate';
import List from '../../../commonComponents/lists/List';
import AcademyCourse from './AcademyCourse';
import JourneyBanner from './journeyBanner/JourneyBanner';
import ServicesContext from '../../../contextProviders/ServicesContext';
import LoggedUserContext from '../../../contextProviders/LoggedUserContext';
import MetaContext from '../../../contextProviders/MetaContext';
import LanguagePrefixContext from '../../../contextProviders/LanguagePrefixContext';
import CountryProp from '../../../commonComponents/forms/Address/CountryProp';
import TextFilter from '../../../commonComponents/lists/filters/TextFilter';
import MarketInfosContext from '../../../contextProviders/MarketInfosContext';
import AcademyFilters from './AcademyFilters';
import CategoryProp from '../propTypes/categoryProp';
import CurrencyProp from '../../profile/propTypes/currencyProp';
import HardSkillProp from '../../challenges/propTypes/hardSkillProp';
import CourseTagProp from '../../../commonComponents/propTypes/CourseTagProp';
import PriceRangeProp from '../propTypes/PriceRangeProp';
import { useDimensions } from '../../../services/customHooks';
import useTrailerTrigger from '../../../services/useTrailerTrigger';
import TrailerModal from '../../../commonComponents/TrailerModal';

function AcademyList(props) {
  const {
    t,
    languages,
    query,
    onChange,
    onQueryChange,
    tags,
    currencies,
    categories,
    priceRange,
    skills,
  } = props;
  const { isMobile } = useDimensions();
  const [isFiltersMobileOpen, setIsFiltersMobileOpen] = useState(false);
  const services = useContext(ServicesContext);
  const { loggedUser } = useContext(LoggedUserContext);
  const languagePrefix = useContext(LanguagePrefixContext);
  const { meta } = useContext(MetaContext);
  const [trailerUrl, closeTrailer] = useTrailerTrigger();

  const handleMobileFilter = () => {
    setIsFiltersMobileOpen(prevState => !prevState);
  };

  const columns = [
    {
      field: 'name',
      textAlign: 'center',
      title: t('academy_name'),
      template: item =>
        item.itemType === ACADEMY_LIST_ITEM_TYPE.COURSE
          ? renderToStaticMarkup(
              <LanguagePrefixContext.Provider value={languagePrefix}>
                <AcademyCourse
                  t={t}
                  meta={meta}
                  course={item}
                  showEnroll={false}
                  showProgress={!item.isFromExternalProvider}
                  showModules={!item.isFromExternalProvider}
                  loggedUser={loggedUser}
                  languages={languages}
                  showPromotion
                  showTeaserVideo
                />
              </LanguagePrefixContext.Provider>,
            )
          : renderToStaticMarkup(
              <LanguagePrefixContext.Provider value={languagePrefix}>
                <JourneyBanner
                  t={t}
                  journey={item}
                  services={services}
                  isLogged={!!loggedUser}
                />
              </LanguagePrefixContext.Provider>,
            ),
    },
  ];
  useEffect(() => {
    $('#searchInput').val(query.search);
  }, [query.search]);
  const { marketInfos } = useContext(MarketInfosContext);
  const params = {
    ...query,
    country: marketInfos.localCountry,
    currency: marketInfos.localCurrency,
  };
  return (
    <>
      <div className="academy-list-search row fix-on-mobile">
        {isMobile && (
          <div className="col-lg-0 col-2 filter-button-shop-container">
            <button type="button" onClick={handleMobileFilter}>
              <i className="fa fa-filter" />
            </button>
          </div>
        )}
        <div className="col-lg-12 col-10 search-container-mobile">
          <TextFilter
            id="searchInput"
            onChange={onChange('search')}
            placeholder={t('search')}
            value={query.search}
          />
        </div>
      </div>
      {isMobile && isFiltersMobileOpen && (
        <AcademyFilters
          currencies={currencies}
          languages={languages}
          categories={categories}
          skills={skills}
          tags={tags}
          selected={query}
          onChange={onQueryChange}
          onPriceChange={onChange}
          priceRange={priceRange}
        />
      )}
      <List
        id="academyList"
        dataSourceURL="/academy/list"
        columns={columns}
        query={params}
      />
      <TrailerModal videoUrl={trailerUrl} onClose={closeTrailer} />
    </>
  );
}

AcademyList.propTypes = {
  /** Translation function */
  t: PropTypes.func.isRequired,
  languages: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  query: PropTypes.shape({ category: PropTypes.string.isRequired, search: PropTypes.string.isRequired }).isRequired,
  onChange: PropTypes.func.isRequired,
  onQueryChange: PropTypes.func.isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape(CategoryProp.propType))
    .isRequired,
  currencies: PropTypes.arrayOf(PropTypes.shape(CurrencyProp.propType))
    .isRequired,
  skills: PropTypes.arrayOf(PropTypes.shape(HardSkillProp.propType)).isRequired,
  priceRange: PropTypes.shape(PriceRangeProp.propType).isRequired,
  tags: PropTypes.arrayOf(PropTypes.shape(CourseTagProp.propType)),
};

AcademyList.defaultProps = {
  tags: [],
};

export default translate(AcademyList);
